import React from 'react';

import { HeaderSlide, HeaderSlideConfig } from './HeaderSlide';
import SymbolsDefs from './SymbolsDefs';
import { useAutoProgress } from './useAutoProgress';
import { useMaxWidth } from '../../hooks/useResponsive';
import BumoCarousel from '../BumoCarousel';
import Dots from '../Dots';

export default function SliderHeader({
  itemsConfig,
}: {
  itemsConfig: HeaderSlideConfig[];
}) {
  const { activeIndex, setActiveIndex } = useAutoProgress(
    itemsConfig.length,
    6000
  );

  const slidesAmount = itemsConfig.length;

  const isMobileDevice = useMaxWidth(800);

  return (
    <>
      <BumoCarousel
        renderedElements={1}
        activeIndex={activeIndex}
        onIndexChange={setActiveIndex}
        itemContainerStyle={{
          padding: 5,
          // backgroundColor: '#ff000044',
        }}
        showArrows={false}
        containerStyle={{
          marginBottom: 20,
          overflow: 'hidden',
          height: 'auto',
          flex: 1,
          marginHorizontal: -5,
        }}
      >
        {itemsConfig.map((item, index) => (
          <HeaderSlide key={index} config={item} mobile={isMobileDevice} />
        ))}
      </BumoCarousel>
      <Dots
        activeIndex={activeIndex}
        amount={slidesAmount}
        dotProps={{
          inactiveColor: '#ddd',
          onPress: (idx) => setActiveIndex(idx),
        }}
      />
      <SymbolsDefs />
    </>
  );
}
